import React from "react"
import ZdqConnectorSetup from "../../components/ZdqConnectorSetup"
import { GENERIC_POSTGRES } from "../../Constants"

function ZdqGenericPostgresConnector() {
    return <ZdqConnectorSetup vendor={GENERIC_POSTGRES}></ZdqConnectorSetup>
}

export default ZdqGenericPostgresConnector 